#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"
#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

fragment postContent on posts_default_Entry {
    uri
    title
    image {
        ...DefaultImageAsset
    }
    video: videoUrl
    description: textarea
    tags {
        title
    }
    postTypes: selectPostType {
        title
    }
    postDate
    showDate: plainSwitch2
    seo {
        ... socialFragment
    }
    flexibleSections {
        ... flexibleSections
    }
    showNewsletterSubscribe
}
